import React from "react";
import { CircularProgress } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";

const LoadingCard = props => {
    let text = "Loading...";
    let color = "#313131";
    if (typeof props.text !== 'undefined') {
        text = props.text;
    }

    if (typeof props.color !== 'undefined') {
        color = props.color;
    }

    if (typeof props.spinner !== 'undefined') {
        props.spinner = true;
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection:"column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "calc(100vh)",
                margin: "0"
            }}
        >
            <CircularProgress style={{fontSize: "2em"}} className="text-blue margin-bottom-16"/>
            <h3 className="">{text}</h3>
        </div>
    )
};

export { LoadingCard }
